



















































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'MyJobsPager',
  components: {},
})
export default class MyJobsPager extends Vue {
  $wlToastr: any;
  private errorString: string = '';
  private successString: string = '';
  private recsPerPage: number = 10;

  get isLastPage(): boolean {
    if (this.currentPage === this.pageCount) {
      return true;
    } else {
      return false;
    }
  }

  ///////////////////////////////////////////////

  get isFirstPage(): boolean {
    if (this.currentPage === 1) {
      return true;
    } else {
      return false;
    }
  }

  ///////////////////////////////////////////////

  get pageCount() {
    if (vxm.jobs.MyJobsPager.totalPages) {
      return vxm.jobs.MyJobsPager.totalPages;
    } else {
      return 0;
    }
  }

  ///////////////////////////////////////////////

  get currentPage() {
    return vxm.jobs.MyJobsPager.resultPage;
  }

  ///////////////////////////////////////////////

  reload() {
    const jhr = vxm.jobs.UserJobListRequest;
    jhr.resultSize = this.recsPerPage;
    vxm.jobs.getJobStatus(jhr);
  }

  ///////////////////////////////////////////////

  getNext() {
    if (this.currentPage < this.pageCount) {
      const jhr = vxm.jobs.UserJobListRequest;
      jhr.resultPage = this.currentPage + 1;
      jhr.resultSize = this.recsPerPage;
      vxm.jobs.getJobStatus(jhr);
    }
  }

  ///////////////////////////////////////////////

  getPrevious() {
    if (this.currentPage > 1) {
      const jhr = vxm.jobs.UserJobListRequest;
      jhr.resultPage = this.currentPage - 1;
      jhr.resultSize = this.recsPerPage;
      vxm.jobs.getJobStatus(jhr);
    }
  }

  ///////////////////////////////////////////////

  getLast() {
    const jhr = vxm.jobs.UserJobListRequest;
    jhr.resultPage = this.pageCount;
    jhr.resultSize = this.recsPerPage;
    vxm.jobs.getJobStatus(jhr);
  }

  ///////////////////////////////////////////////

  getFirst() {
    const jhr = vxm.jobs.UserJobListRequest;
    jhr.resultPage = 1;
    jhr.resultSize = this.recsPerPage;
    vxm.jobs.getJobStatus(jhr);
  }

  //////////////////////////////////////////////////

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  //////////////////////////////////////////////////

  mounted() {
    if (vxm.users.isLoggedIn) {
      console.log(vxm.jobs.UserJobListRequest);
      this.recsPerPage = vxm.jobs.UserJobListRequest.resultSize;
    }
  }
}
